import type { UnpublishDiffusionForProductMutationResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { partenaires } from '~/msw/mocks/diffusion'

export function unpublishDiffusionForProductHandler() {
  return http.post<
    { annonceId: string, codeProduit: string },
    never,
    UnpublishDiffusionForProductMutationResponse
  >('http://localhost:3000/api/v1/diffusions/:annonceId/depublier/:codeProduit', ({ params }) => {
    const produit = partenaires.find(p => p.code === params.codeProduit)?.label ?? params.codeProduit
    return HttpResponse.json({
      produit,
      success: true,
      message: 'Annonce dépubliée avec succès',
    })
  })
}

// Variante « scenario » de l'endpoint : la dépublication d'un produit échoue (HTTP 500).
// Branchée via ?scenario=unpublishError et composée dans ~/msw/scenarios.ts.
export function unpublishDiffusionForProductErrorHandler() {
  return http.post(
    'http://localhost:3000/api/v1/diffusions/:annonceId/depublier/:codeProduit',
    () => HttpResponse.json({ message: 'Échec de la dépublication' }, { status: 500 }),
  )
}
